import { atom } from 'jotai';
import {
  dictationCsatCounterAtom,
  rollDictationCsatCadence,
} from '../bubble/csat/dictationCsatAtoms';
const COOLDOWN_AFTER_PROMPT = 30;

/**
 * Rolls the existing Dictation CSAT cadence for the after-dictating feedback
 * prompt without opening the legacy star-rating popover.
 *
 * The persisted counter is shared with the legacy survey so enabling or
 * disabling the feedback flag preserves the user's place in the cadence.
 */
export const dictationFeedbackPromptIncrementAtom = atom(null, (get, set) => {
  const { nextCounter, shouldShow } = rollDictationCsatCadence(
    get(dictationCsatCounterAtom)
  );

  set(dictationCsatCounterAtom, nextCounter);
  return shouldShow;
});

/** Starts the 30-success cooldown after a shown prompt is completed or dismissed. */
export const dictationFeedbackPromptCooldownAtom = atom(null, (_, set) => {
  set(dictationCsatCounterAtom, -COOLDOWN_AFTER_PROMPT);
});
